export function TheScorekeeperIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="24" r="16" />
      <circle cx="24" cy="24" r="11" />
      <path d="M24 13v11l7 5" />
      <circle cx="24" cy="8" r="1.5" fill="currentColor" />
      <circle cx="24" cy="40" r="1.5" fill="currentColor" />
      <circle cx="8" cy="24" r="1.5" fill="currentColor" />
      <circle cx="40" cy="24" r="1.5" fill="currentColor" />
    </svg>
  );
}
